@let configValue = config();
@let selectedFilesValue = files();
@let disabled = effectiveDisabled();
@if (selectedFilesValue.length > 0) {
  <mat-card [class.!shadow-none]="hideCardShadow()">
    <mat-card-content>
      <div>
        @for (
          fileResponse of selectedFilesValue;
          track `${fileResponse.file.name}${fileResponse.file.size}${fileResponse.file.lastModified}`;
          let last = $last
        ) {
          @let file = fileResponse.file;
          @let success = !(fileResponse | isErrorFileUploadResponse);
          @let i18nScope = `${effectiveI18nScope()}.MATERIAL_FILE_LIST.`;
          <div class="grid grid-cols-1 md:grid-cols-[1fr_auto] gap-4 items-center">
            <div class="grid grid-cols-1 gap-2">
              <div>
                <div
                  class="break-words"
                  style="font: var(--mat-sys-label-large)"
                  [class.!text-[var(--mat-sys-error)]]="!success"
                  >{{ file.name }}</div
                >
                <div
                  style="font: var(--mat-sys-label-small)"
                  [class.!text-[var(--mat-sys-error)]]="!success"
                  [class.text-gray-600]="success"
                >
                  {{
                    `${i18nScope}SIZE`
                      | transloco
                        : { size: (file.size | formatFileSize), type: file.type || 'Unknown' }
                  }}
                  {{
                    `${i18nScope}MODIFIED`
                      | transloco: { modified: (file.lastModified | dateOrTimestampToLocaleString) }
                  }}
                  @if (!success) {
                    <mat-divider class="!my-4" />
                    {{
                      `${i18nScope}ERROR`
                        | transloco: { error: (fileResponse.message | resolveTranslateAbleText) }
                    }}
                  }
                </div>
              </div>
            </div>
            @let showPreview = configValue | showPreview: file;
            @let removable = configValue | isRemovable: file;
            @if (removable || showPreview) {
              <div class="flex gap-2 items-center">
                @if (showPreview) {
                  @if (file | isImageFile) {
                    <button
                      mat-icon-button
                      type="button"
                      [disabled]="disabled"
                      (click)="onClickOpenPreview(file)"
                    >
                      <mat-icon customMatSvgIcon="pct-mdi-image-multiple" />
                    </button>
                  }
                }
                @if (removable) {
                  <button
                    mat-icon-button
                    type="button"
                    [disabled]="disabled"
                    (click)="onClickRemove(fileResponse)"
                    ><mat-icon customMatSvgIcon="pct-mdi-delete"
                  /></button>
                }
              </div>
            }
          </div>
          @if (!last) {
            <mat-divider class="!my-4" />
          }
        }
      </div>
    </mat-card-content>
  </mat-card>
}
